import Modal from '@/components/common/Modal'
import { Popup, type PopupProps } from '@collable/ui'
import { createContext, useContext, useState } from 'react'

type PopupContextType = {
  popup: PopupProps | null
  openPopup: (popup: PopupProps) => void
  closePopup: () => void
}

export const PopupContext = createContext<PopupContextType>({
  popup: null,
  openPopup: () => {},
  closePopup: () => {},
})

export const usePopup = () => useContext(PopupContext)

export const PopupProvider = ({ children }: { children: React.ReactNode }) => {
  const [popup, setPopup] = useState<PopupProps | null>(null)

  const openPopup = (popup: PopupProps) => {
    setPopup(popup)
  }

  const closePopup = () => {
    setPopup(null)
  }

  return (
    <PopupContext.Provider value={{ popup, openPopup, closePopup }}>
      {children}
      {popup && (
        <Modal onClose={closePopup}>
          <Popup {...popup} onClose={closePopup} />
        </Modal>
      )}
    </PopupContext.Provider>
  )
}
